import { Branding } from '../Branding';
import cciLogo from '../../assets/CCI_Logo_burgundy.svg';

export const cciBranding: Branding = {
  name: 'CCI',
  logo: cciLogo,
  orgEmail: 'cci@ccidiomas.es',
  orgPhone: '+34 91 563 37 78',
  privacyPolicyUrl: 'https://www.ccidiomas.es/politica-de-privacidad/',
  defaultLocale: 'es',
  withPayment: false,
};
